import React from "react";
import { Paragraph } from "components/Typography";
import { Link } from "@mui/material";

// eslint-disable-next-line
export default {
  title: "Bio",
  data: (
    <>
      <Paragraph variant="body2">
        Andrés Guadarrama (Ciudad de México, 1991) es un compositor, intérprete
        y artista sonoro nacido en la Ciudad de México. Actualmente su trabajo
        gira alrededor de temas como la ecología del espacio performático, la
        agencia de los objetos, y el estudio e incorporación de saberes
        ancestrales. A través de su trabajo diseña redes físicas de interacción
        e interdependencia entre personas, objetos, espacios y fuerzas
        naturales.
      </Paragraph>
      <Paragraph variant="body2">
        Su música ha sido interpretada distintos países de América, Europa y
        Asía por músicos como{" "}
        <Link variant="body2" href="https://www.yarnwire.org/">
          Yarn/Wire
        </Link>
        , Joseph Houston,{" "}
        <Link variant="body2" href="http://umsnjip.ch/">
          UMS ’n JIP
        </Link>
        ,{" "}
        <Link variant="body2" href="http://www.eva-zoellner.de/">
          Eva Zöllner
        </Link>
        ,{" "}
        <Link variant="body2" href="https://www.tallersonoro.com/">
          Taller Sonoro
        </Link>
        , Boglárka Nagy, Irvine Arditti,
        <Link variant="body2" href="http://www.tambuco.org/">
          Tambuco
        </Link>
        , entre otros; y programada en festivales como Donaueschinger Musiktage,
        NUNC! 4, The 21st Century Guitar Conference, Forum Wallis, Jornadas de
        Música Contemporánea CCMC, Foro Internacional de Música Nueva Manuel
        Enríquez.
      </Paragraph>
      <Paragraph variant="body2">
        Ha recibido reconocimientos como la beca FONCA Jóvenes Creadores;
        comisiones del{" "}
        <Link variant="body2" href="https://jackquartet.com/">
          JACK Quartet
        </Link>
        ,{" "}
        <Link variant="body2" href="https://robertoalonsotrillo.com/">
          Roberto Alonso Trillo
        </Link>{" "}
        y{" "}
        <Link variant="body2" href="https://www.tetractysnewmusic.com/">
          Tetraktys New Music
        </Link>
        ; y el representar a México en la 63va Tribuna Internacional de
        Compositores de la UNESCO en Wrocław, Polonia.
      </Paragraph>
      <Paragraph variant="body2">
        Como intérprete, Andrés es miembro de los ensambles de música nueva
        Attica! y XIN.
      </Paragraph>
      <Paragraph variant="body2">
        Andrés estudió composición y teoría musical en el Centro de
        Investigación y Estudios de la Música (CIEM). Posteriormente estudió con
        los compositores Germán Romero y Samuel Cedillo.
      </Paragraph>
    </>
  ),
};
